import React, { useEffect, useRef, useState } from 'react';
import config from '../config.js';

    const Timeline = ({ containerRef, current_step = false, use_gradient = false, use_middle_placement = true, use_text = false }) => {


    const [points, setPoints] = useState([]);
    const [gradient, setGradient] = useState('');

    const calculatePoints = () => {
        if (containerRef.current) {
            const colors = config.getCustomColors();
            let current_color = colors.mlime;
            let gradient = "linear-gradient(to bottom ";
            let step = 0
            let old_top = 0

            const points = [];
            const elements = containerRef.current.querySelectorAll('.timeline-big-item, .timeline-item');
            elements.forEach(el => {
                const rect = el.getBoundingClientRect();
                const isBigItem = el.classList.contains('timeline-big-item');
                let top = 0;
                let isCurrent = false;
                let classes = ''

                // Calcul de la position de l'élément
                if (isBigItem) {
                    top = rect.top - containerRef.current.getBoundingClientRect().top;
                  // Un titre (big item) est TOUJOURS vert et ne représente pas une étape
                  current_color = colors.mlime;
                  isCurrent = false;
                }
                else {
                    if (el?.nextElementSibling?.classList.contains('timeline-item') || use_middle_placement) {
                        top = rect.top  - containerRef.current.getBoundingClientRect().top + rect.height / 2;
                    }
                    else {
                        top = rect.bottom  - containerRef.current.getBoundingClientRect().top;
                    }

                    // Pour la section "suiviclient", on force la couleur verte
                   const insideSuivi = !!el.closest('#suiviclient');
                    if (insideSuivi) {
                        current_color = colors.mlime;
                    } else {
                        if (current_step !== false) {
                            if (step > current_step) current_color = colors.mgray2;   // à venir
                            else if (step < current_step) current_color = colors.mlime; // terminé
                            else { current_color = colors.morange; isCurrent = true; } // en cours
                            step++;
                        } else {
                            current_color = colors.mgray2;
                        }
                    }
                }
                if (!use_text) {
                    classes = isBigItem ? 'size-6 ' : 'size-3 -translate-y-1/2';                    
                }
                else {
                    classes = isBigItem ? 'text-sm py-0.5 px-1.5 -translate-y-1/2' : 'text-xs py-0.5 px-1.5'; 
                }

                gradient += ', ' + current_color + ' ' + old_top + 'px, ' + current_color + ' ' + top + 'px';
                old_top = top;
                // console.log(el);
                points.push({ top, isBigItem, current_color, isCurrent, text: el.dataset.html, classes  });
            });
            gradient += ')';

            setPoints(points);
            setGradient(use_gradient ? gradient : "");
        }
    }

    useEffect(() => {
        calculatePoints();

        const handleResize = () => {
            calculatePoints();
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div className="relative flex flex-col items-center h-full">
            <div className="absolute w-0.5 bg-gray-300 h-full left-1/2 transform -translate-x-1/2" style={{ backgroundImage: gradient }}></div>
            {points.map((point, index) => (
                <div key={index} className={`${point.classes} ${point.isCurrent && !use_text ? 'size-6' : ''} absolute  rounded-full text-white text-sm`} style={{ top: point.top, backgroundColor: point.current_color }}>{use_text ? point.text : ''}</div>
            ))}
        </div>
    );
};

export default Timeline;
